.trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  text-align: start;
  cursor: pointer;
}

.value {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trigger[data-placeholder] .value {
  color: var(--color-text-subtle);
}

.chevron {
  color: var(--color-text-muted);
}

.content {
  z-index: var(--z-popover);
  width: var(--radix-select-trigger-width);
  max-height: min(360px, var(--radix-select-content-available-height));
  overflow: hidden;
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-surface-raised);
  box-shadow: var(--shadow-lg);
}

.viewport {
  padding: var(--space-1);
}

.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  min-height: var(--control-md);
  padding: var(--space-1-5) var(--space-3);
  border-radius: var(--radius-sm);
  font-size: var(--text-md);
  cursor: pointer;
  outline: none;
  user-select: none;
}

.item[data-highlighted] {
  background: var(--color-surface-hover);
}

.item[data-disabled] {
  opacity: 0.45;
  cursor: not-allowed;
}

.itemText {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.detail {
  color: var(--color-text-muted);
  font-size: var(--text-xs);
}

.indicator {
  color: var(--color-accent-text);
}
